var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMosaicFullscreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.871,
    height: 36.51,
    viewBox: "0 0 36.871 36.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3331",
    "data-name": "Group 3331",
    transform: "translate(-267.486 -19.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M278.434,31.409a1,1,0,0,1-.71-.3l-9.949-10.044a1,1,0,0,1,1.421-1.408L279.144,29.7a1,1,0,0,1-.71,1.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M268.486,30.082a1,1,0,0,1-1-1V19.012h10.258a1,1,0,0,1,0,2h-8.258v8.07a1,1,0,0,1-1,1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M268.839,55.521a1,1,0,0,1-.7-1.71l10.046-9.948a1,1,0,0,1,1.408,1.421l-10.046,9.947a1,1,0,0,1-.7.29",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M277.557,55.521H267.486V45.263a1,1,0,0,1,2,0v8.258h8.071a1,1,0,0,1,0,2",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M303.357,55.168a1,1,0,0,1-.71-.3L292.7,44.827a1,1,0,0,1,1.421-1.408l9.948,10.045a1,1,0,0,1-.71,1.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M304.357,55.521H294.1a1,1,0,0,1,0-2h8.258v-8.07a1,1,0,0,1,2,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M292.957,30.96a1,1,0,0,1-.7-1.71L302.3,19.3a1,1,0,0,1,1.408,1.421L293.661,30.67a1,1,0,0,1-.7.29",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M303.357,30.269a1,1,0,0,1-1-1V21.011h-8.071a1,1,0,0,1,0-2h10.071V29.269a1,1,0,0,1-1,1",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosaicFullscreen);
export default __webpack_public_path__ + "static/media/MosaicFullscreen.2bb02d127e10acd3734d3f0646989606.svg";
export { ForwardRef as ReactComponent };